import React from 'react';
import PropTypes from 'prop-types';
import button from './../../hocs/button';

const Button = ({ hasErrors, captchaValidated, ...props }) => {

  return <button {...props} disabled={hasErrors || !captchaValidated} />;
};

Button.contextTypes = {
  hasErrors: PropTypes.bool
};

export default button(Button);



// WEBPACK FOOTER //
// ./src/components/layouts/react-validation/components/button/index.js